import React, { lazy, useEffect, useState, useRef } from "react";
import RequestService from "../../utils/fetch";
const ConditionalWrapper = lazy(() => import("../../utils/ConditionalWrapper"));
import SkeletonList from "../Skeleton/List";
const List = lazy(() => import("../List"));
function TmsHeroJobs() {
    const configName = "myTalentionConfig";
    const configObject = window[configName] || {};
    const [filterObject, setFilterObject] = useState({
        category: configObject.category || configObject.heroJobs?.category || [],
        id: configObject.heroJobs?.id || [],
        // skill: ["Berufseinsteiger"] // Test
    });
    const [paginationObject, setPaginationObject] = useState({
        resultsTotal: 0,
        maxResults: configObject.heroJobs?.max || 1,
        offset: 0
    });
    const [sorterObject, setSorterObject] = useState({
        sorter: configObject.heroJobs?.jobSorter || "enabledDate",
        sorterOrder: configObject.heroJobs?.jobSorterOrder || "desc",
    });
    const [interval, setIntervalState] = useState(configObject.heroJobs?.interval);
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState();
    const [storedJobs, setStoredJobs] = useState([]);
    // Ref to hold the current state of paginationObject
    const paginationRef = useRef(paginationObject);
    const storedRef = useRef(storedJobs);
    const handleAPICall = () => {
        // Get latest state from ref
        const currentPagination = paginationRef.current;
        const currentStored = storedRef.current;
        RequestService.postRequest(`${configObject.clientURL}talention/api/3.2/job`, {
            filter: filterObject,
            sorter: {
                sort: configObject.heroJobs?.jobSorter || "enabledDate",
                order: configObject.heroJobs?.jobSorterOrder || "desc"
            },
            pagination: {
                max: currentPagination.maxResults,
                offset: currentPagination.offset,
            },
        }).then((jobs) => {
            setData(() => {
                // Append the stored jobs at the end of results, for seamless transition
                if (jobs.resultsTotal < jobs.maxResults + jobs.offset) {
                    // In case heroJobs.max is greater than the actually available jobs then we have to append all stored jobs
                    const decreasedOffset = configObject.heroJobs?.max >= jobs.resultsTotal ? 0 : -1;
                    const payload = {
                        ...jobs,
                        results: [...jobs.results, ...currentStored.slice(0, jobs.offset + decreasedOffset)]
                    };
                    payload.results.splice(configObject.heroJobs?.max);
                    return payload;
                }
                // Return jobs if loop is not ending
                return jobs;
            });
            // Store the first iteration of jobs, so we can append them later
            if (jobs.offset === 0 && storedJobs.length === 0) {
                setStoredJobs(jobs.results.slice(0, configObject.heroJobs?.max - 1));
            }
            setPaginationObject((oldObj) => {
                return {
                    ...oldObj,
                    resultsTotal: jobs.resultsTotal,
                    offset: jobs.offset + 1 < jobs.resultsTotal ? jobs.offset + 1 : 0, // we check if it is the last job, when totalresults is equal offset + 1
                };
            });
            if (isLoading) {
                setIsLoading(false);
            }
        });
    };
    // Keep ref in sync with state
    useEffect(() => {
        paginationRef.current = paginationObject;
    }, [paginationObject]);
    useEffect(() => {
        storedRef.current = storedJobs;
    }, [storedJobs]);
    useEffect(() => {
        handleAPICall();
        if (!interval)
            return;
        const heroInterval = setInterval(handleAPICall, interval);
        return () => clearInterval(heroInterval);
    }, [interval]);
    if (isLoading) {
        return React.createElement("div", null,
            React.createElement(SkeletonList, { filter: configObject.heroJobs.properties.length || 2, count: configObject.heroJobs.max }));
    }
    return (React.createElement("section", { className: "tms-herojobs-wrap" }, !isLoading ? React.createElement(List, { attributes: configObject.link, parameter: configObject.parameterQuery, jobSorter: sorterObject, showJoblistButton: configObject.heroJobs?.showJoblistButton, jobListButtonText: configObject.heroJobs?.buttonText, disableJoblistLink: configObject.heroJobs?.disableJoblistLink, jobListProperties: configObject.heroJobs?.properties, disableJobListTitleWrap: configObject.heroJobs?.disableTitleWrap, disableJobListPropertyWrap: configObject.heroJobs?.disablePropertyWrap, items: data.results })
        : null));
}
export default TmsHeroJobs;
